import TUIContact from './index.vue';
export default TUIContact;